<template>
  <div class="container payments">
    <h1 class="mb-45">
      Payments
    </h1>

    <div class="row" v-if="!payments">
      <Loader style="width: 100%;" />
    </div>

    <div class="row" v-else-if="payments.length === 0">
      You do not have any payments yet.
    </div>

    <div class="row" v-else>
      <div class="col-12">
        <div class="dashboard-card d-none d-md-block">
          <responsive-payment-table :payments="payments" :payNow="payNow" />
        </div>
        <div class="d-md-none">
          <responsive-payment-table :payments="payments" :payNow="payNow" />
        </div>
      </div>
    </div>

    <submit-payment-modal
      ref="paymentModal"
      :paymentPaidWithCredits="paymentPaidWithCredits" />
  </div>
</template>

<script>
import ResponsivePaymentTable from '@/components/tables/ResponsivePaymentTable.vue';
import SubmitPaymentModal from '@/components/modals/SubmitPaymentModal.vue';
import Loader from '@/components/Loader';
import StudentClient from '@/api/StudentClient';
import UserClient from '@/api/UserClient';

export default {
  name: 'Payments',
  components: {
    ResponsivePaymentTable,
    SubmitPaymentModal,
    Loader,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      studentClient: new StudentClient(this.$http),
      payments: null,
    };
  },
  mounted() {
    this.$store.commit('clearGlobalAlerts');
    const { from } = this.$route.params;
    if (from && from === 'payment') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Payment Sent!',
      });
    } else if (from && from === 'payment-error') {
      this.$store.commit('setGlobalAlert', {
        msg: 'Failed to submit payment! Please try again.', error: true,
      });
    }

    this.getPayments();
  },
  methods: {
    async payNow(paymentModel) {

      const { 
        individual_session_credits_remaining,
        group_session_credits_remaining,
      } = await this.studentClient.getRemainingCredits();

      this.studentClient.getPaymentDetail(paymentModel.id).then(payment => {
        this.$refs.paymentModal.show(payment, individual_session_credits_remaining, group_session_credits_remaining);
      }).catch(ex => {
        this.selectedPayment = null;
      });
    },
    paymentPaidWithCredits(id) {
      this.getPayments();
      this.$store.commit('setGlobalAlert', {
        msg: 'Payment Sent!',
      });

      this.userClient.getNumberOfPendingPayments().then(num_pending_payments => {
        const user = this.$store.getters.currentUser;
        user.num_pending_payments = num_pending_payments || 0;
        this.$store.commit('setUser', user);
      });
    },
    async getPayments() {
      try {
        const payments = await this.studentClient.getMyPayments(null, 100, 0);
        this.payments = payments.items || [];
      } catch(ex) {
        console.error(ex)
        this.payments = [];
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
